<section>
  <mat-spinner
    *ngIf="loadingChart"
    aria-label="Loading Regression"
    class="rds-regression-chart--loader"
    color="accent"
    diameter="144"
    i18n-aria-label
    mode="indeterminate"
  ></mat-spinner>
  <div #regressionChart class="rds-regression-chart" [class.hide]="loadingChart"></div>
</section>
